export const HEADER_SECONDARY_COLOR = "#0f172a";
export const HEADER_PRIMARY_COLOR = "#14213d";
export const HEADER_TERTIARY_COLOR = "#070b16";
export const HEADER_GRADIENT = `linear-gradient(135deg, ${HEADER_SECONDARY_COLOR} 0%, ${HEADER_PRIMARY_COLOR} 60%, ${HEADER_TERTIARY_COLOR} 100%)`;
export const HEADER_ACCENT_COLOR = HEADER_PRIMARY_COLOR;
